
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.747 31.816C52.015 20.093 43.54 9.562 31.816 8.295 20.093 7.027 9.562 15.503 8.295 27.226 7.027 38.95 15.503 49.48 27.226 50.747 38.95 52.015 49.48 43.54 50.747 31.816z","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M44.698 25.335c0 1.55-1.63 2.49-2.99 1.72-.92-.52-1.86-.99-2.85-1.39-1.95-.78-3.97-1.31-6.04-1.67a39.794 39.794 0 00-8.89-.53c-1.74.09-3.46.28-5.16.65-.63.14-1.25.31-1.87.47-.38.1-.76.11-1.14 0-.83-.24-1.4-.99-1.43-1.86-.02-.85.5-1.63 1.32-1.9.6-.2 1.22-.35 1.83-.5 1.53-.35 3.07-.57 4.63-.71 1.66-.15 3.32-.2 4.98-.15 4.09.12 8.1.72 11.99 2.06 1.58.55 3.11 1.22 4.56 2.07.52.3.86.73.99 1.31.03.14.04.28.06.43h.01zM25.368 30.096c-2.44.01-4.94.31-7.38 1.04-.4.12-.8.13-1.19-.03-.63-.26-1.05-.89-1.02-1.56.02-.7.45-1.31 1.13-1.52.69-.21 1.39-.39 2.09-.55 1.73-.38 3.48-.59 5.25-.65 3.81-.14 7.53.35 11.16 1.51 1.84.59 3.59 1.36 5.25 2.34.08.05.16.1.25.15.86.53.97 1.59.56 2.27-.47.78-1.45 1.02-2.27.56-.46-.26-.91-.53-1.38-.77-2.16-1.1-4.44-1.81-6.81-2.26-1.83-.35-3.67-.51-5.63-.52l-.01-.01zM25.748 33.716c2.81.03 5.55.41 8.22 1.31 1.47.5 2.87 1.14 4.21 1.93.12.07.23.14.34.22.54.41.68 1.15.33 1.73-.34.56-1.05.79-1.66.52-.12-.05-.24-.13-.35-.2-2.26-1.34-4.7-2.17-7.29-2.57-1.59-.24-3.19-.33-4.8-.26-2.08.08-4.13.37-6.16.82-.21.05-.42.09-.62.09-.63 0-1.16-.44-1.27-1.04-.12-.64.2-1.24.79-1.48.12-.05.26-.08.39-.11 1.66-.37 3.34-.65 5.03-.8.95-.08 1.9-.11 2.85-.16h-.01z","fill":"currentColor"}})])
          )
        }
      }
    